import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';
import {
  ListWarehouseScheduleEntriesActions as Actions,
  ListWarehouseScheduleRequestAction as RequestAction,
} from 'store/ducks/scheduling';

export function* listWarehouseScheduleEntriesRequest(action: any) {
  const { query, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = applyQueryString('scheduling/warehouse-schedule', query);
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
